/** 右侧面板入口：0 选中 → 页面属性；1 选中 → 图层属性；多选 → 批量操作。 */
import { Button, Space } from 'antd';
import { selectCurrentPage, selectSelectedLayers, useEditorStore } from '../store/store';
import { LayerPanel } from './LayerPanel';
import { PagePanel } from './PagePanel';

export function PropsPanel() {
  const page = useEditorStore(selectCurrentPage);
  const layers = useEditorStore(selectSelectedLayers);
  const { removeLayers, duplicateLayers } = useEditorStore.getState();

  if (!page) return null;
  if (layers.length === 0) return <PagePanel page={page} />;
  if (layers.length === 1) return <LayerPanel layer={layers[0]!} />;
  const ids = layers.map((l) => l.id);
  return (
    <div style={{ padding: 12 }}>
      <div style={{ fontWeight: 500, marginBottom: 12 }}>已选中 {layers.length} 个图层</div>
      <Space direction="vertical" style={{ width: '100%' }}>
        <Button block onClick={() => duplicateLayers(ids)}>复制</Button>
        <Button block danger onClick={() => removeLayers(ids)}>删除</Button>
      </Space>
    </div>
  );
}
